import getJSON from '@api/api_helper';

export default (sectionId) => (
  getJSON('/api/v3/printui/sync', {
    params: {
      section_id: sectionId,
    },
  })
);
